// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OneTrustErrorBanner_wrapper__MVZ1I"};